import React from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';

import { CaretDownOutlined } from '@ant-design/icons';
import { changeLanguage } from 'states/common/actions';
import useActions from 'hooks/useActions';
import { selectLanguage } from 'states/common/selectors';

import './style.scss';
import { setMomentLocale } from 'utilities/time';
import { languages, setLang } from 'utilities/lang';
import { useChangeLanguage } from 'hooks/useProfile';
import { useBranding } from 'hooks/useBranding';
const { Option } = Select;

const Language = (props) => {
  const {
    domainConfig: { languages: availableLanguages = [] },
  } = useBranding();
  const [changeLanguageAction] = useActions([changeLanguage]);
  const defaultLang = useSelector(selectLanguage());

  const updateLanguage = useChangeLanguage();
  const handleChange = (value) => {
    if (props.isPublicRoute) {
      setLang(value);
      setMomentLocale(value);
      changeLanguageAction(value);
    } else {
      updateLanguage.mutate(
        { languageCode: value },
        {
          onSuccess: () => {
            setMomentLocale(value);
            changeLanguageAction(value);
            setLang(value);
            window.location.reload();
          },
        }
      );
    }
  };

  return (
    <Select
      {...props}
      defaultValue={defaultLang}
      className="lang-wrapper mr-16"
      suffixIcon={<CaretDownOutlined />}
      onChange={handleChange}
    >
      {Object.entries(languages)
        .filter(([_, value]) => availableLanguages.includes(value))
        .map(([key, value]) => {
          return (
            <Option key={key} value={value}>
              <div className="lang-item">{key}</div>
            </Option>
          );
        })}
    </Select>
  );
};

export default Language;
